export default {
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    keyboard: true,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-details-content/slider-config.js